export const TaskType = Object.freeze({
  CREDIT_CONSENT: 'CREDIT_CONSENT',
  CREDIT_STATUS_ESKAT: 'CREDIT_STATUS_ESKAT',
  MARKETING_CONSENT: 'MARKETING_CONSENT',
  SIGNING: 'SIGNING',
  CUSTOMER_LANDING: 'CUSTOMER_LANDING',
  DIGITAL_AGREEMENT_SIGNING: 'DIGITAL_AGREEMENT_SIGNING',
  AUTHENTICATION: 'AUTHENTICATION',
  PSP: 'PSP',
  PEP: 'PEP',
})

export const TaskStatus = Object.freeze({
  INITIALIZED: 'INITIALIZED',
  AWAITING_VERIFICATION: 'AWAITING_VERIFICATION',
  COMPLETED: 'COMPLETED',
  CANCELED: 'CANCELED',
  DECLINED: 'DECLINED',
})

export const ApplicantType = Object.freeze({
  MAIN_APPLICANT: 'MAIN_APPLICANT',
  CO_APPLICANT: 'CO_APPLICANT',
})
